import { z } from 'zod';

export const formSchema = z.object({
  columns: z.array(z.string()).optional(),
});

export type FormSchema = z.infer<typeof formSchema>;

